// extracted by mini-css-extract-plugin
export default {"webcam":"Webcam_webcam__z6JRF","webcam__close":"Webcam_webcam__close__xsLn3","webcam__button":"Webcam_webcam__button__pMtq+"};